import moment from 'moment';
import _ from 'lodash';

import Timesheet from './timesheets/timesheet.model';
import angular from "angular";

const CHARGECODE_ID_PTO = 31
const CHARGECODE_ID_LWOP = 1011

class TimesheetService {
  constructor($http, $rootScope, SettingsService, AuthenticationService) {
    "ngInject";
    this.$http = $http;
    this.baseUrl = $rootScope.apiHost + "/api/timesheets/";
    this.$rootScope = $rootScope;
    this.currentTimesheet = new Timesheet();
    this.persistedTimesheet = new Timesheet();
    this.settingsService = SettingsService;
    this.authenticationService = AuthenticationService;
    this.timesheetReminders = [];
  }

  getChargeCodeNames(){
    let chargeCodes = new Set(this.currentTimesheet.timeEntries.map(entry => entry.chargeCode.name));
    return Array.from(chargeCodes);
  }

  getLeaveChargeCodes(){
    let chargeCodes = {};
    for(let i=0;i<this.currentTimesheet.timeEntries.length;i++){
      let te = this.currentTimesheet.timeEntries[i];
      if(te.chargeCode.leaveType) {
        if (!chargeCodes[te.chargeCode.name]) {
          chargeCodes[te.chargeCode.name] = te.chargeCode;
        }
      }
    }

    let ccArray = Object.values(chargeCodes);

    let c =  _.sortBy(ccArray, [function(o) { return o.id; }]).reverse();
    return c;
  }

  getNonLeaveChargeCodes(){
    let chargeCodes = {};
    for(let i=0;i<this.currentTimesheet.timeEntries.length;i++){
      let te = this.currentTimesheet.timeEntries[i];
      if(!te.chargeCode.leaveType) {
        if (!chargeCodes[te.chargeCode.name]) {
          chargeCodes[te.chargeCode.name] = te.chargeCode;
        }
      }
    }

    return Object.values(chargeCodes);
  }

  hasChargeCode(chargeCodeName) {
    return this.getChargeCodeNames().indexOf(chargeCodeName) > -1;
  }

  isTimesheetLocked() {
    return this.lockedStatus = ['REJECTION_REQUESTED', 'APPROVED'].indexOf(this.currentTimesheet.status.toUpperCase()) > -1;
  }

  dirtyCheck() {
    if(!angular.equals(this.currentTimesheet.timeEntries, (this.persistedTimesheet.timeEntries))){
      this.currentTimesheet.dataDirty = true;
    } else {
      this.currentTimesheet.dataDirty = false;
    }
  }

  async loadTimesheet(date) {
	  this.url = this.baseUrl + moment(date).format('YYYY-MM-DD');

    try {

      const response = await this.$http.get(this.url, {withCredentials: true});

      this.deltaChargeHoursFromPersisted = 0
      this.currentTimesheet = new Timesheet();
      this.persistedTimesheet = new Timesheet();

      this.currentTimesheet.populateTimesheet(response.data, this.settingsService, this.authenticationService.user);
      this.persistedTimesheet.populateTimesheet(response.data, this.settingsService, this.authenticationService.user);

      let today = moment().format('YYYY-MM-DD');
      this.timesheetReminders = [];
      if(moment(this.currentTimesheet.endDate).isSame(today)) {
        this.timesheetReminders.push({
          message: 'Today is the last day of the timesheet period. Please remember to submit your time!'
        });
      }

      this.$rootScope.$apply();

      return this.currentTimesheet; // Return the loaded timesheet

    } catch (response) {
      console.error('Failed to load timesheet:', response);
      throw response; // Re-throw the error
    }


  }

  getHolidays() {
    return this.currentTimesheet.info.holidays;
  }

  getTotalWeekends(){
    return this.currentTimesheet.info.weekends;
  }

  getTotalHoursForTimesheet() {
    return Math.round(this.currentTimesheet.info.timesheetHours);
  }

  addTimesheetReminder(reminder) {
    // If the reminder has a type, check to see if we already have a reminder
    // of that type before adding it
    let addReminder = true
    if (reminder.type && this.timesheetReminders.find(r => r.type === reminder.type)) {
      addReminder = false
    }

    if (addReminder) {
      this.timesheetReminders.push(reminder)
    }
  }

  removeTimesheetReminder(type) {
    if (type) {
      const index = this.timesheetReminders.findIndex(r => type === r.type)
      if (index !== -1) {
        this.timesheetReminders.splice(index, 1)
      }
    }
  }

  addChargeCodeToTimesheet(chargeCode) {
    this.currentTimesheet.addChargeCode(chargeCode);
  }

  getTimeEntriesForChargeCode(chargeCodeName) {
    let q = [];
    for(let i=0; i < this.currentTimesheet.timeEntries.length; i++){
      let te = this.currentTimesheet.timeEntries[i];

      if(te.chargeCode.name === chargeCodeName){
        q.push(te);
      }
    }

    return q;
  }

  calculateTimeEntryBasedInfo() {
    this.currentTimesheet.calculateTimeEntryBasedInfo()
    this.setDeltaChargedHoursFromPersistentTimesheet()
  }

  setDeltaChargedHoursFromPersistentTimesheet() {
    // Accumulate chargeable hours for timesheet
    const getChargeableHours = (hours, te) => {
      let chargeableHours = 0
      if (!te.chargeCode.leaveType) {
        chargeableHours = te.hours || 0
      }
      return hours + chargeableHours
    }

    const currentTimesheetHours = this.currentTimesheet.timeEntries.reduce(getChargeableHours, 0)
    const persistedTimesheetHours = this.persistedTimesheet.timeEntries.reduce(getChargeableHours, 0)

    this.deltaChargeHoursFromPersisted = currentTimesheetHours - persistedTimesheetHours
  }

  getHoursForChargeCodeFromCurrentTimesheet(chargeCodeId) {
    return this.getChargeCodeHours(this.currentTimesheet.timeEntries, chargeCodeId)
  }

   getChargeCodeHours(timeEntries, chargeCodeId) {
    return timeEntries.reduce(
      (totalHrs, te) => te.chargeCode.id === chargeCodeId ? totalHrs + (te.hours || 0) : totalHrs, 0)
  }


  postRest(action) {
    let config = {};
    config.headers = {
      'Content-Type': 'application/json',
      'action': action
    }
    config.withCredentials = true;
    let timeSheet = {
      startDate: this.currentTimesheet.startDate,
      endDate: this.currentTimesheet.endDate,
      status:  this.currentTimesheet.status,
      approver: this.currentTimesheet.approver,
      timeEntries: this.currentTimesheet.timeEntries,
      id: this.currentTimesheet.id
    }

    return this.$http.post(this.baseUrl + this.currentTimesheet.id, timeSheet, config);
  }

  saveTimesheet(action){
    return this.postRest(action);
  }

  approveTimesheet(timesheetId) {
    let config = {};
    config.headers = {
      'Content-Type': 'application/json'
    }
    config.withCredentials = true;
    return this.$http.post(this.$rootScope.restEndpointRoot + "timesheet-review/"+timesheetId+"?action=approve", timesheetId, config);
  }

  rejectTimesheet(timesheetId, rejectionReason) {
    let config = {};
    config.headers = {
      'Content-Type': 'application/json'
    }
    config.withCredentials = true;
    return this.$http.post(this.$rootScope.restEndpointRoot + "timesheet-review/"+timesheetId+"?action=reject", rejectionReason, config);
  }

  sendSubmitReminder(timesheetId) {
    let config = {};
    config.headers = {
      'Content-Type': 'application/json'
    }
    config.withCredentials = true;
    return this.$http.post(this.$rootScope.restEndpointRoot + "timesheet-review/"+timesheetId+"?action=remind", '', config);
  }

  /**
   * The given timeEntry has the potential to change lwop status and hours for all
   * subsequent time entries. Checks and adjusts all necessary time entries for lwop status and hours.
   *
   * @param {*} timeEntry the updated time entry
   */
  adjustLeaveEntriesForLwop(timeEntry) {
    if (this.autoLwopService.state.disabled) {
      return
    }

    // Get all leave time entries on and after the timeEntry.date if given
    const leaveTimeEntries = timeEntry
    ? this.currentTimesheet.timeEntries.filter((te) => te.chargeCode.leaveType && te.date >= timeEntry.date)
    : this.currentTimesheet.timeEntries.filter((te) => te.chargeCode.leaveType)

    // Organize all leave hours by charge code
    const leaveHours = {}
    leaveTimeEntries.forEach((te) => {
      if (!leaveHours[te.date]) {
        leaveHours[te.date] = {}
      }
      leaveHours[te.date][te.chargeCode.id] = te.hours
    })

    // At this point, assume all time entries have been already autobalanced for leave (pto +/- added)
    // Check each date against leaveTracker to see if it's lwop status and move hours accordingly.
    const leaveHourDates = Object.keys(leaveHours)
    leaveHourDates.forEach((date) => {
      const lwopInfo = this.autoLwopService.leaveTracker[date]
      const leaveHoursForDate = leaveHours[date]

      const ptoHours = leaveHoursForDate[CHARGECODE_ID_PTO]
      const lwopHours = leaveHoursForDate[CHARGECODE_ID_LWOP]

      // This assumes lwop and pto hours are exclusive or.
      // This shouldn't be the case if we want precise application of LWOP hours, but for now keep it this way.
      // console.log(date, 'isLwop', lwopInfo)
      if (lwopInfo.isLwop) {
        // if isLwop move all PTO hours to LWOP charge code
        if (ptoHours && ptoHours > 0) {
          // console.log('moving', ptoHours, 'from pto to lwop')
          this._moveHoursPtoToLwop(date, false)
        }
      } else {
        // if !isLwop move all LWOP hours to PTO charge code
        if (lwopHours && lwopHours > 0) {
          // console.log('moving', lwopHours, 'from lwop to pto')
          this._moveHoursLwopToPto(date, false)
        }
      }
    })

    // Regardless of lwop status, PTO hours earned by working > 8hrs a day
    // should be applied towards reducing the LWOP balance if it is > 0.
    // const lwopBalance = this.currentTimesheet.timeEntries.reduce((lwopHrs, te) => te.chargeCode.id === CHARGECODE_ID_LWOP ? lwopHrs + (te.hours || 0) : lwopHrs, 0)
    let lwopBalance = this.getHoursForChargeCodeFromCurrentTimesheet(CHARGECODE_ID_LWOP)
    // console.log('lwopBalance before checking earned leave', lwopBalance)

    // Find the first lwop entry with hours
    // We want to check for negative PTO after this date, since they are allowed to earn PTO prior to this date
    const firstLwopEntry = this.currentTimesheet.timeEntries.find(te => te.chargeCode.id === CHARGECODE_ID_LWOP && te.hours > 0)

    // Only proceed if we have a first lwop entry
    if (firstLwopEntry && lwopBalance > 0) {
      // Check only pto entries after the first lwop entry
      this.currentTimesheet.timeEntries.filter(te => te.chargeCode.id === CHARGECODE_ID_PTO && te.date > firstLwopEntry.date).forEach((te) => {
        const ptoTe = te

        // We are after the first lwop entry and we found a pto entry with negative hours while we have an lwop balance
        if (ptoTe.hours < 0 && lwopBalance > 0) {
          console.log('lwopBalance', lwopBalance, ptoTe.date)

          const earnedPtoHours = -ptoTe.hours

          // If the PTO earned is less than the lwop balance, apply the whole amount
          if (earnedPtoHours <= lwopBalance) {
            // console.log('moving earned pto to lwop', earnedPtoHours)
            this._moveHoursPtoToLwop(ptoTe.date, false)
            lwopBalance -= earnedPtoHours
          }
          // If the PTO earned is more than what's left in the lwop balance, move enough to zero out lwop and leave the rest
          else {
            const earnedLwopHours = lwopBalance
            const earnedPtoHoursRemainder = earnedPtoHours - earnedLwopHours

            // console.log('moving earned pto to lwop', earnedLwopHours)

            // We have to set the hours we want to move first
            ptoTe.hours = -earnedLwopHours
            this._moveHoursPtoToLwop(ptoTe.date, false)

            // At this point, lwop balance should be 0, apply the rest to pto
            ptoTe.hours = -earnedPtoHoursRemainder

            // console.log('earned pto remaining in pto', ptoTe.hours)
          }
        }
      })
    }
  }

  getDailyTotal(date) {
    const entries = this.currentTimesheet.getTimeEntriesForDate(date);
    return entries.reduce((total, entry) => total + (entry.hours || 0), 0);
  }

  getNonAutoBalanceLeaveDailyTotal(date) {
    const entries = this.currentTimesheet.getNonAutoBalanceLeaveTimeEntriesForDate(date);
    return entries.reduce((total, entry) => total + (entry.hours || 0), 0);
  }

  getNonAutoBalanceDailyTotal(date) {
    const entries = this.currentTimesheet.getNonAutoBalanceTimeEntriesForDate(date);
    return entries.reduce((total, entry) => total + (entry.hours || 0), 0);
  }

  getNonLeaveDailyTotal(date) {
    const entries = this.currentTimesheet.getNonLeaveTimeEntriesForDate(date);
    return entries.reduce((total, entry) => total + (entry.hours || 0), 0);
  }

  getTimeEntryForDateAndChargeCode(date, chargeCodeId) {
    return _.find(this.currentTimesheet.timeEntries, (timeEntry) => moment(timeEntry.date).isSame(date) && timeEntry.chargeCode.id === chargeCodeId);
  }


  getMode(timeEntry) {
    
    let persistedTimeEntry = this.persistedTimesheet.getTimeEntry(timeEntry.chargeCode, timeEntry.date);
    
    let hasPersistedEntry = (persistedTimeEntry !== undefined) && (persistedTimeEntry.hours !== undefined);
    let hasNewTimeEntry = timeEntry.hours !== undefined;

    let mode = 0;

    // First time adding hours to entry
    mode = (!hasPersistedEntry && hasNewTimeEntry) ? 1 : mode;

    // Update existing entry with a value (allows null) that is different from the persisted value (??)
    // NOTE: The different usages of null vs undefined is confusing here, is it intentional
    mode = ( (hasPersistedEntry && hasNewTimeEntry) && (timeEntry.hours !== persistedTimeEntry.hours)) ? 2 : mode;

    // Update existing entry that had hours but now setting it to undefined (??)
    mode = (hasPersistedEntry && !hasNewTimeEntry && persistedTimeEntry.hours !== 0) ? 3 : mode;

    return mode;
  }



  /**
   * For a particular date in the timesheet, move hours from one chargecode to another.
   *
   * @param {*} date
   * @param {*} fromChargeCodeId
   * @param {*} toChargeCodId
   * @param {*} swap whether to swap hours from given chargecodes or move from one to another.
   * @returns
   */
  _moveTimeEntryHours(date, fromChargeCodeId, toChargeCodId, swap) {
    const timeEntries = this.currentTimesheet.getTimeEntriesForDate(date)

    // Find pto and lwop entries for the date
    let fromEntry, toEntry
    timeEntries.some((te) => {
      if (te.chargeCode.id === fromChargeCodeId) {
        fromEntry = te
      } else if (te.chargeCode.id === toChargeCodId) {
        toEntry = te
      }

      // We are done when we found both entries
      return fromEntry && toEntry
    })

    if (!fromEntry || !toEntry) {
      console.warn('Both from and to time entries must exist', fromEntry, timeEntry)
      return
    }

    const fromHours = fromEntry.hours
    const toHours = toEntry.hours

    if (swap) {
      fromEntry.hours = toHours
      toEntry.hours = fromHours
    } else {
      fromEntry.hours = 0
      toEntry.hours = toHours + fromHours
    }
  }

  _moveHoursPtoToLwop(date, swap) {
    this._moveTimeEntryHours(date, CHARGECODE_ID_PTO, CHARGECODE_ID_LWOP, swap)
  }

  _moveHoursLwopToPto(date, swap) {
    this._moveTimeEntryHours(date, CHARGECODE_ID_LWOP, CHARGECODE_ID_PTO, swap)
  }
}

let timesheetsModule = angular.module('timesheets', []).service('TimesheetService', TimesheetService);
export default timesheetsModule;



// WEBPACK FOOTER //
// ./client/pages/timesheet/services/timesheet.service.js